import * as Yup from "yup";

export const MaterialTypeFormSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
});
